import {
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { DataTableComponent } from "../data-table/data-table.component";
import { GenericContentDirective } from "../../directives/content.directive";
import { MapBoxComponent } from "../map-box/map-box.component";
import { PieChartComponent } from "../pie-chart/pie-chart.component";
import { Card } from "./card.type";

type AllowedComponents = DataTableComponent<unknown> | PieChartComponent | MapBoxComponent;

@Component({
  selector: "app-card",
  templateUrl: "./card.component.html",
  styleUrls: ["./card.component.scss"],
})
export class CardComponent<T extends AllowedComponents> implements OnInit, OnChanges {
  @Input() config: Card<T>;
  @ViewChild(GenericContentDirective, { static: true })
  content: GenericContentDirective;
  componentRef: ComponentRef<T>;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit(): void {
    this.loadComponent();
  }

  ngOnChanges(_changes: SimpleChanges): void {
    if (this.componentRef?.instance instanceof (PieChartComponent || MapBoxComponent)) {
      this.setData(this.componentRef);
    }
  }

  loadComponent(): void {
    const component = this.config.component;
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory<T>(component);
    const viewContainerRef = this.content.viewContainerRef;
    viewContainerRef.clear();
    this.componentRef = viewContainerRef.createComponent<T>(componentFactory);

    this.setData(this.componentRef);
  }

  /** Set the data (usually an input) to the component */
  setData(componentRef: ComponentRef<T>): void {
    if (componentRef.instance instanceof DataTableComponent) {
      componentRef.instance.config = this.config.data.dataTable;
      componentRef.instance.getData.subscribe((event) =>
        this.config.data.getDataTable(event.onResult, event.onError, event.queryParams),
      );
      return;
    }
    if (componentRef.instance instanceof PieChartComponent) {
      componentRef.instance.config = this.config.data;
      return;
    }
    if (componentRef.instance instanceof MapBoxComponent) {
      componentRef.instance.config = this.config.data;
      return;
    }
  }
}
